//
//
//
//
//
//
//
//
//

export default {
  props: {
    top: {
      type: Number,
      default: 0
    }
  },
  beforeDestroy () {
    $(window).off();
  },
  data() {
    return {

    }
  },
  mounted: function () {
    this.init();
  },
  methods: {
    init(){
      let _this = this;
      let m = _this.ismobile();
      //$('body').append('<p>m(0为ios6+系统):' + m + '</p>');
      if(m === 1){//(0为ios6+系统)
        let $obj = $('.sticky'),
          $box = $('.stickyBox'),
          boxTop = $box.offset().top - _this.top;
        $box.height($obj.outerHeight());
        $(window).on('scroll', function(){
          let top = $(this).scrollTop();
          _this.scrollPlaceTop($obj, $box, top, boxTop);
        })
      }
      this.$nextTick(() => {
        $('.stickyParent').after($('.sticky'));
      })
    },
    ismobile(){
      var ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        //alert("iphone");
        var ver = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        ver = ver && parseInt(ver[1], 10);
        //$('body').append('<p>ver:' + ver + '</p>')
        if(ver && ver < 6){
          return 1;
        }
      } else if (/android/.test(ua)) {
        //alert("android");
        return 1;
      }
      return 0;
    },
    scrollPlaceTop($obj, $box, top, boxTop){
      if(top > boxTop){
        $obj.addClass('fix');
        $box.removeClass('static');
      }else{
        $obj.removeClass('fix');
        $box.addClass('static');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/sticky/sticky.vue